import React from 'react'

import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

import { BasePermissionsForm, BaseMultiPermissionsForm } from '../'

import constants from 'constants/index'

import ActivitiesInfoBanner from './components/ActivitiesInfoBanner'

const PermissionsForm = ({
  register,
  permissions,
  handleChange,
  activeProfile,
  isEdit,
}) => {
  const permission = constants.permissionsLists

  return (
    <>
      <Box mt={2} mb={3}>
        <Typography variant="h4">Permissões</Typography>
      </Box>
      <BasePermissionsForm
        title="Atividades"
        permissionsList={permission.taskList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
        infoBanner={<ActivitiesInfoBanner />}
      />
      <BasePermissionsForm
        title="Canal de denúncias"
        permissionsList={permission.complaintList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Comitês"
        permissionsList={permission.committeeList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Consentimentos"
        permissionsList={permission.consentList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Cookies"
        permissionsList={permission.cookiesList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Credenciais de SMTP"
        permissionsList={permission.smtpCredentialList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Integrações com Plataformas Externas"
        permissionsList={permission.externalPlatformIntegrationList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Dados cadastrais da empresa"
        permissionsList={permission.companyList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Dados financeiros"
        permissionsList={permission.paymentList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Departamentos"
        permissionsList={permission.departmentList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BaseMultiPermissionsForm
        title="Diagnóstico"
        permissionsLists={[
          {
            title: 'Medidas de segurança',
            permissions: permission.diagnosticsList,
          },
          { title: 'Questionário', permissions: permission.questionnaireList },
          { title: 'Ameaças', permissions: permission.companyFragilities },
        ]}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Documentos"
        permissionsList={permission.privacyPolicyList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Documentos modelos"
        permissionsList={permission.documentTemplateList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BaseMultiPermissionsForm
        title="Fornecedores"
        permissionsLists={[
          {
            title: 'Meus Fornecedores e Pré Avaliados',
            permissions: permission.companySuppliers,
          },
          {
            title: 'Questionários Recebidos',
            permissions: permission.companySupplierQuestionnairesReceivedList,
          },
          {
            title: 'Sugestões',
            permissions: permission.supplierSuggestionsList,
          },
        ]}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Gestão de mudanças"
        permissionsList={permission.changesManagementList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BaseMultiPermissionsForm
        title="Governança de IA"
        permissionsLists={[
          {
            title: 'Inventário de IA',
            permissions: permission.aiInventoryList,
          },
        ]}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Incidentes"
        permissionsList={permission.incidentList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Inventário de ativos"
        permissionsList={permission.assetInventoryList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Marketplace"
        permissionsList={permission.marketplaceList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Indicadores"
        permissionsList={permission.dashboardList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BaseMultiPermissionsForm
        title="Monitoramento"
        permissionsLists={[
          {
            title: 'KPI',
            permissions: permission.monitoringManagementKpiList,
          },
          {
            title: 'PMC',
            permissions: permission.monitoringManagementPmcList,
          },
          {
            title: 'PDCA',
            permissions: permission.monitoringManagementPdcaList,
          },
          {
            title: 'NC',
            permissions: permission.monitoringManagementNcList,
          },
        ]}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Perfis"
        permissionsList={permission.profileList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Personalização do canal de comunicação"
        permissionsList={permission.privacyPortalThemeList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Privacy By Design"
        permissionsList={permission.privacyByDesignList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BaseMultiPermissionsForm
        title="Processos"
        permissionsList={permission.dataProcessList}
        permissionsLists={[
          {
            permissions: permission.dataProcessList,
          },
          { title: 'Auditoria', permissions: permission.auditList },
        ]}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Projetos de governança"
        permissionsList={permission.governanceProjectList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Recibos de consentimentos"
        permissionsList={permission.consentReceiptList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Relatórios"
        permissionsList={permission.ripdList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Solicitação de titulares"
        permissionsList={permission.titularTicketList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Treinamentos"
        permissionsList={permission.trainingList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Últimas atualizações"
        permissionsList={permission.lastUpdate}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BaseMultiPermissionsForm
        title="Usuários"
        permissionsList={permission.userList}
        permissionsLists={[
          {
            permissions: permission.userList,
          },
          {
            title: 'Notificação para finalizar treinamento',
            permissions: permission.trainningJourneyList,
          },
        ]}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Vulnerabilidades"
        permissionsList={permission.phishingList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
    </>
  )
}

PermissionsForm.propTypes = {
  register: PropTypes.func,
  permissions: PropTypes.object,
  handleChange: PropTypes.func,
  activeProfile: PropTypes.bool,
  isEdit: PropTypes.bool,
}

export default PermissionsForm
